var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.72875 30 0 23.2712 0 15C0 6.72875 6.72875 0 15 0C23.2712 0 30 6.72875 30 15C30 23.2712 23.2712 30 15 30ZM15 1.25C7.41875 1.25 1.25 7.41875 1.25 15C1.25 22.5812 7.41875 28.75 15 28.75C22.5812 28.75 28.75 22.5812 28.75 15C28.75 7.41875 22.5812 1.25 15 1.25ZM16.44 23.75C15.5413 23.75 14.7725 23.1713 14.5238 22.3075L13.23 16.7725L7.72625 15.52C6.82625 15.2625 6.24625 14.49 6.25 13.5888C6.2525 12.6875 6.83875 11.9187 7.70625 11.675L22.505 7.4925L18.3612 22.2937C18.1187 23.1612 17.3488 23.7475 16.4487 23.75H16.44ZM20.7 9.30125L8.04375 12.8775C7.64375 12.99 7.5 13.32 7.49875 13.5925C7.49875 13.8637 7.6375 14.195 8.0375 14.31L14.2688 15.7275L15.7325 21.9925C15.8388 22.3587 16.1688 22.5 16.4387 22.5H16.4412C16.7137 22.5 17.0425 22.3563 17.155 21.9563L20.7 9.30125Z",
    fill: "#110505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftarrow);
export default __webpack_public_path__ + "static/media/giftarrow.7415bf084217eb839f7d91740dcd2b07.svg";
export { ForwardRef as ReactComponent };